import {Layout, theme} from "antd";
import "./style.scss";

const { Footer } = Layout;
const { useToken } = theme;

export const PageFooter = () => {
    const { token } = useToken();
    return (
    <div className="main-footer-bt" style={{ zIndex: 6 }}>
      <Footer className="footer-content" style={{background: token.footerBgColor}}>
        <span>© 2023 M I Synergy. All rights reserved. - NDB Wealth Management Customer Portal - Version 0.0.0.3</span>
      </Footer>
    </div>
    );
};
